import { createContext, useContext } from "react";

/**
 * Interface for the AttachLmsDocuments context
 */
export interface IAttachLmsDocumentsContext {
    value: {
        folders: number[];
        files: number[];
    };
    handleUpdate: (newValue: IAttachLmsDocumentsContext["value"]) => void;
}

/**
 * Default context values
 */
export const defaultContextValue: IAttachLmsDocumentsContext = {
    value: {
        folders: [],
        files: [],
    },
    handleUpdate: () => {},
};

/**
 * Create the context with default values
 */
export const AttachLmsDocumentsContext = createContext<
    IAttachLmsDocumentsContext | undefined
>(undefined);

/**
 * Custom hook to use the AttachLmsDocuments context
 * @returns AttachLmsDocuments context
 */
export const useAttachLmsDocuments = (): IAttachLmsDocumentsContext => {
    const context = useContext(AttachLmsDocumentsContext);

    if (!context) {
        throw new Error(
            "useAttachLmsDocuments must be used within an AttachLmsDocumentsProvider"
        );
    }

    return context;
};
